import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 18px;
  height: 18px;
  color: #cfcfcf;

  /* Remove this, make it part of the button it lives inside of */
  &:hover {
    color: #aaa;
  }
`

const Remove = ({ title = 'Remove', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 18 18" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="surveys-questions-2c" transform="translate(-869.000000, -650.000000)">
        <g id="surveys-audience2">
          <g id="Add-questions" transform="translate(331.000000, 429.000000)">
            <g id="circle-remove-copy-4" transform="translate(538.000000, 221.000000)">
              <circle id="Oval" fill="currentColor" cx="9" cy="9" r="9" />
              <path
                d="M12.3157895,5.68421053 L5.68421053,12.3157895"
                id="Shape"
                stroke="#FFFFFF"
                strokeWidth="2"
                strokeLinecap="square"
              />
              <path
                d="M12.3157895,12.3157895 L5.68421053,5.68421053"
                id="Shape"
                stroke="#FFFFFF"
                strokeWidth="2"
                strokeLinecap="square"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Remove.displayName = 'Remove'
Remove.needsWork = true
export default Remove
